import Cookies from 'js-cookie';
import {ADJUST_SUITE_CUSTOM_LINK} from './constants';

export const getAppStoreUrl = () => {
  const cuid = localStorage.getItem('cuid');
  const campaignId = Cookies.get('campaignID');
  const partnerCode = Cookies.get('partnerCode');

  // Construct query parameters for the deeplink itself
  const deepLinkParams = new URLSearchParams();
  if (cuid) deepLinkParams.append('cuid', cuid);
  if (campaignId) deepLinkParams.append('campaignID', campaignId);
  if (partnerCode) deepLinkParams.append('partnerCode', partnerCode);

  const deeplinkBase = 'com.ferryscanner.mobile://';
  const deeplinkWithParams = deepLinkParams.toString()
    ? `${deeplinkBase}?${deepLinkParams.toString()}`
    : deeplinkBase;

  const finalParams = new URLSearchParams({
    deeplink_js: '1',
    deeplink: deeplinkWithParams
  });

  return `${ADJUST_SUITE_CUSTOM_LINK}?${finalParams.toString()}`;
};
